module.exports = __webpack_public_path__ + "static/img/COC2023-20.c2b25c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-20.png
// module id = pvLr
// module chunks = 0